module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0743d_logo_200x200.d6eb5a05.png";